import faceAuthenticationService from '../../../services/faceAuthentication';
import Result from '../../../common/result';
import { BackgroundTaskResult } from './ValidationBackgroundProcessing';

export default class BackgroundInitialization {
  private initializationTask: Promise<BackgroundTaskResult> | null = null;

  private async runBackgroundTask(): Promise<BackgroundTaskResult> {
    await faceAuthenticationService.initialize();
    return Result.noValueSuccess();
  }

  public run(): void {
    this.initializationTask = this.runBackgroundTask();
  }

  public async wait(): Promise<void> {
    const result = await this.initializationTask;
    result?.logError('BackgroundInitialization: Error awaiting initialization task');
  }
}
